import { employeeAgentList } from '../../api';
import { useQuery } from '@tanstack/react-query';
import { useAlert } from '../useAlert';

export default function useEmployeeAgentList({ get_owner = 'N' } = {}) {
  const { showAlert } = useAlert();
  const Request = useQuery({
    queryFn: () =>
      employeeAgentList({
        page: 1,
        limit: 100,
        get_owner, // Y OR N
      }),
    queryKey: ['employeeAgentList'],
    select: (data) => data?.data?.data || [],
    onError: (error) => {
      const errMsg = error?.message ?? 'unexpected error';
      showAlert({ type: 'secondary', message: errMsg });
    },
  });
  return { ...Request };
}
